import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { Order } from "../../../../services";
import Loading from "../../../shared/Loading/Loading";
import { acceptstatus, rejectstatus } from "../../../../mock";
import cn from "classnames";
import style from "../common.module.scss";
import CustomButton from "../../../custom/custom-button/CustomButton";

const OrderBookingStatus = ({ order, user, onUpdateData, fetchOrderData }) => {
  const { t } = useTranslation();
  const [actionSuccess, setActionSuccess] = useState(false);
  const [bookingFailed, setBookingFailed] = useState(false);
  const [loading, setLoading] = useState(false);


  const updateStatus = () => {
    if (order.status === "booked") {
      let currentDate = new Date();
      let dt = new Date(order.shippingDate);
      let shippingDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 23, 59, 0);

      if (currentDate.getTime() > shippingDate.getTime()) {
        toast.error(t('orderBookingStatus.shippingDateExpired', 'Дата погрузки просрочена. Необходимо изменить дату погрузки!!!'));
        return;
      }
    }

    setLoading(true);
    const status = acceptstatus(order.status);
    Order.bookUpdateStatus(order.id, "confirmed", user.name)
      .then(() => {
        setLoading(false);
        setActionSuccess(true);
        toast.success(t('orderBookingStatus.bookingConfirmed', 'Бронирование подтверждено'));
        if (onUpdateData) onUpdateData();
        if (fetchOrderData) fetchOrderData();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        toast.error(t('orderBookingStatus.genericError', 'Произошла ошибка при подтверждении бронирования'));
      });
  };

  const rejectConfirm = () => {
    setLoading(true);
    const status = rejectstatus(order.status);
    Order.rejectConfirm(order.id, status, user.name, "")
      .then(() => {
        setLoading(false);
        setBookingFailed(true);
        toast.info(t('orderBookingStatus.bookingRejected', 'Бронирование отклонено'));
        if (onUpdateData) onUpdateData();
        if (fetchOrderData) fetchOrderData();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        toast.error(t('orderBookingStatus.genericError', 'Произошла ошибка при отклонении бронирования'));
      });
  };

  if (!order || order.status !== "booked") {
    return null;
  }

  return (
    <div className={cn(style.cargo_wrapper)} style={{display: "initial"}}>
      {loading && <Loading />}
      <div>
        {actionSuccess || bookingFailed ? (
          actionSuccess ? (
            <div>
              <img src="/icons/tick-success.svg" height="16px" alt="Success" />
            </div>
          ) : (
            <div style={{ color: "red", fontWeight: "800" }}>
              {t('orderBookingStatus.rejected', 'Отклонен')}
            </div>
          )
        ) : (
          <>
            <div className={cn(style.cargo_wrapper)}>
              <div className={cn(style.cargo_title, style.orders_title)}>
                {t('orderInfo.orderDecision.acceptRejectTitle')}
              </div>
              <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                <CustomButton
                  text={t('orderInfo.orderDecision.acceptButton')}
                  style={{ flex: "1" }}
                  onClick={updateStatus}
                  isLoading={loading}
                />
                <CustomButton
                  text={t('orderInfo.orderDecision.rejectButton')}
                  style={{ flex: "1" }}
                  onClick={rejectConfirm}
                  isLoading={loading}
                  isWhite
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OrderBookingStatus;